export default "__VITE_ASSET__rgk1hkMJ__"